import { createReducer, on } from '@ngrx/store';
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setYAxisDate } from './y-axis-date.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const yAxisDate = createReducer(null, on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.pointInTime) {
        return action.scatterPlot.yAxisDate;
    }
    return state;
}), on(setYAxisDate, (state, { date }) => {
    return date;
}));
